// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HXSG","content":"styles_content__17_rY"};